var t=function(t){return!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(t)};export{t as isInvalidEmail};
//# sourceMappingURL=isInvalidEmail.js.map
